import React, { FC, useEffect, useState } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { Card, CardBody, CardSubtitle, CardTitle, Col, ListGroup, ListGroupItem, Row } from "reactstrap";
import { formatCurrency } from "../../../utils/formats";
import invoicesService from "../../../services/invoices.service";
import { toast } from "react-toastify";
import { select2Styles } from "../../../helpers/functions_helper";
import { currentYear, options, yearOptions } from "../../../common/staticdata";
import { noData } from "../../../utils/data";
import LoadingSpinner from "../../../components/Common/Loader";
import Chart from "../../../components/Chart";

type TopClientsProps = {
    hideHeading?: boolean;
}
const TopClients: FC<TopClientsProps> = ({ hideHeading = false }) => {

    const { t } = useTranslation();

    const [loadingText, setLoadingText] = useState<string>('Loading...');
    const [loading, setLoading] = useState<boolean>(true);
    const [formValues, setFormValues] = useState<any>({
        service_charge: currentYear,
    })

    const [d2Chart, setD2Chart] = useState<any>({
        options: {
            plotOptions: {
                pie: {
                    donut: {
                        size: '0%'
                    },

                }
            },
            // colors: ['#fbf103', '#34c38e'],
            labels: {
                trim: true,
            },
            legend: {
                show: true,
                trim: true,
                position: 'left',
                formatter: function (value: any) {
                    return value.substr(0, 40);
                }
            },
            yaxis: {
                labels: {
                    formatter: function (value: any) {
                        return formatCurrency(value);
                    }
                },
            },

        },
        noData: noData,
        series: [44, 55],

    })


    const getTopClients = async (range: any) => {
        setLoadingText("Loading...");
        setLoading(true);
        try {
            const res = await invoicesService.getTopClients(range);
            if (res.status === 'success') {
                setD2Chart((state: any) => ({ ...state, series: res.all?.map((x: any) => x.total), options: { ...state.options, labels: res.labels, noData: noData } }))
            }
            setLoadingText("No data found");
            setLoading(false);
        } catch (error: any) {
            toast(error)
        }
    }

    useEffect(() => {
        getTopClients(formValues.service_charge);
    }, [formValues.service_charge])


    return (
        <div style={{ height: '375px' }}>
            <div className="d-sm-flex flex-wrap">
                <div>
                    {!hideHeading && <CardTitle className="mb-3">{t("Top Clients")}</CardTitle>}
                </div>
                <div className="ms-auto">
                    <Select
                        id="service_charge"
                        name="service_charge"
                        className="form-select-sm myClassName"
                        styles={select2Styles}
                        value={yearOptions.find((i: any) => i.value === formValues.service_charge)}
                        options={yearOptions}
                        onChange={(option: any) => {
                            setFormValues((state: any) => ({ ...state, service_charge: option.value }))
                        }}
                    />
                </div>
            </div>
            <Chart loading={loading} options={d2Chart.options} series={d2Chart.series} type="pie" height={350} />
        </div>

    )
}

export default TopClients;